import { Typography } from '@mui/material';
import { ProgressBarWithArrow } from './ProgressBarWithArrow';
import { ThemePalette } from 'mui.theme';
import { useNavigate } from 'react-router-dom';
import { SWToolTip } from 'components/SWToolTip';
import {
  evaluateNumber,
  numberEvaluationKeyMappings,
} from '../components/AssetCardsV2/utils';

export const FleetOverviewV2GridItem = ({
  value = {},
  enableDarkTheme,
  type,
  kpiThresholds = {},
  disabled = false,
}: any) => {
  const navigate = useNavigate();

  const thresholdMappings = numberEvaluationKeyMappings(type);

  return (
    <>
      <SWToolTip
        title={
          disabled
            ? 'No data available for category at this site'
            : `${`Click for drill-down to view Fuel Usage for ${
                type === 'total' ? 'all Fleet' : type
              }`}`
        }
      >
        <Typography
          component="div"
          sx={{
            fontSize: '12px',
            textAlign: 'center',
            color: enableDarkTheme
              ? ThemePalette.typography.white
              : ThemePalette.typography.black,
            cursor: 'pointer',
          }}
          onClick={() => {
            if (type && !disabled) {
              navigate(`/fuel-usage`, {
                state: {
                  type,
                  value: value.fuel,
                },
              });
            }
          }}
        >
          <ProgressBarWithArrow
            value={evaluateNumber(
              value.fuel,
              thresholdMappings.fuelUsage,
              kpiThresholds
            )}
            enableDarkTheme={enableDarkTheme}
            disabled={disabled}
          />
          Fuel Usage
        </Typography>
      </SWToolTip>

      <SWToolTip
        title={
          disabled
            ? 'No data available for category at this site'
            : `${`Click for drill-down to view Utilization for ${
                type === 'total' ? 'all Fleet' : type
              }`}`
        }
      >
        <Typography
          component="div"
          sx={{
            fontSize: '12px',
            textAlign: 'center',
            color: enableDarkTheme
              ? ThemePalette.typography.white
              : ThemePalette.typography.black,
            cursor: 'pointer',
          }}
          onClick={() => {
            if (type && !disabled) {
              navigate(`/utilization`, {
                state: {
                  type,
                },
              });
            }
          }}
        >
          <ProgressBarWithArrow
            value={evaluateNumber(
              value.utilization,
              thresholdMappings.utilization,
              kpiThresholds
            )}
            enableDarkTheme={enableDarkTheme}
            disabled={disabled}
          />
          Utilization
        </Typography>
      </SWToolTip>

      <SWToolTip
        title={
          disabled
            ? 'No data available for category at this site'
            : `${`Click for drill-down to view Production for ${
                type === 'total' ? 'all Fleet' : type
              }`}`
        }
      >
        <Typography
          component="div"
          sx={{
            fontSize: '12px',
            textAlign: 'center',
            color: enableDarkTheme
              ? ThemePalette.typography.white
              : ThemePalette.typography.black,
            cursor: 'pointer',
          }}
          onClick={() => {
            if (type && !disabled) {
              navigate(`/production/:assetVin`, {
                state: {
                  type,
                },
              });
            }
          }}
        >
          {/** Others is dozer */}
          {type === 'Others' ? (
            <>{''}</>
          ) : (
            <>
              <ProgressBarWithArrow
                value={evaluateNumber(
                  value.production,
                  thresholdMappings.productivity,
                  kpiThresholds
                )}
                enableDarkTheme={enableDarkTheme}
                disabled={disabled}
              />
              Production
            </>
          )}
        </Typography>
      </SWToolTip>
    </>
  );
};
